import React, { useState } from 'react'
import logo from '../../assets/image/logo.png';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import '@fortawesome/fontawesome-free/css/all.min.css';
import axios from 'axios';
import dev_image from '../../assets/image/dev.jpeg'
import chessimg4 from '../../assets/image/chessimg4.jpeg'
import parv_img from '../../assets/image/parv.jpeg'
import samarth_img from '../../assets/image/samarth.jpeg'
import aarav_img from '../../assets/image/aarav.jpeg'
import chessimg17 from '../../assets/image/chessimg17.jpeg'



const Home = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };


    const [formData, setFormData] = useState({
        name: "",
        childName: "",
        contactNumber: "",
        email: "",
        familiarity: "",
        childAge: "",
        city: "",
        preferredDate: "",
        demoMode: "Offline (At the Academy)",
        check: 1
    });

    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
        setErrors((prev) => ({ ...prev, [name]: "" })); // clear error on typing
    };



    const validateForm = () => {
        const newErrors = {};

        if (!formData.name.trim()) newErrors.name = "Parent name is required!";
        if (!formData.childName.trim()) newErrors.childName = "Child name is required!";
        if (!formData.contactNumber.trim()) newErrors.contactNumber = "Contact number is required!";
        else if (!/^[0-9]{10}$/.test(formData.contactNumber))
            newErrors.contactNumber = "Enter a valid 10-digit number!";
        if (!formData.email.trim()) newErrors.email = "Email is required!";
        else if (!/\S+@\S+\.\S+/.test(formData.email))
            newErrors.email = "Enter a valid email!";
        if (!formData.familiarity.trim()) newErrors.familiarity = "Please select familiarity level!";
        if (!formData.childAge) newErrors.childAge = "Child age is required!";
        if (!formData.city.trim()) newErrors.city = "City is required!";
        if (!formData.preferredDate.trim()) newErrors.preferredDate = "Preferred date is required!";
        if (!formData.demoMode.trim()) newErrors.demoMode = "Please select a demo mode!";

        console.log(newErrors);


        setErrors(newErrors);
        return Object.keys(newErrors).length === 0; // return true if no errors
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) return;

        setLoading(true); // show loader

        try {
            const res = await axios.post("http://localhost:5544/api/HomeEmailSend", formData);

                 if (res.data.success === 1) {
        setFormData({   name: "",
        childName: "",
        contactNumber: "",
        email: "",
        familiarity: "",
        childAge: "",
        city: "",
        preferredDate: "",
        demoMode: "Offline (At the Academy)",
        check: 1 });
      }
            alert("Form submitted successfully!");
        } catch (error) {
            console.error("Error sending mail:", error);
            alert("Failed to send email. Try again!");
        } finally {
            setLoading(false); // hide loader
        }
    };


    return (
        <div className='relative'>

            {/* Add mobile responsive meta tag */}
            <meta name="viewport" content="width=device-width, initial-scale=1.0" />

            {loading && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="flex flex-col items-center">
                        <div className="w-16 h-16 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
                        <p className="text-white mt-4 text-lg">Sending...</p>
                    </div>
                </div>
            )}

            {/* Add responsive CSS */}
            <style>
                {`
                /* Base responsive styles */
                @media (max-width: 768px) {
                    /* Header and Navigation */
                    .logo img {
                        height: 70px !important;
                        width: auto !important;
                    }
                    
                    .main-menu {
                        display: none !important;
                    }
                    
                    .mobile_menu {
                        display: block !important;
                    }
                    
                    /* Mobile Menu Toggle Button */
                    .mobile-menu-toggle {
                        display: block !important;
                        position: absolute;
                        right: 20px;
                        top: 20px;
                        background: none;
                        border: none;
                        font-size: 24px;
                        color: #333;
                        z-index: 1001;
                        cursor: pointer;
                        padding: 5px;
                    }
                    
                    /* Mobile Menu Styles */
                    .mobile-menu-container {
                        display: none;
                        position: fixed;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        background: rgba(0, 0, 0, 0.9);
                        z-index: 1000;
                        overflow-y: auto;
                    }
                    
                    .mobile-menu-container.active {
                        display: block;
                    }
                    
                    .mobile-menu-content {
                        background: white;
                        margin-top: 80px;
                        margin-left: 20px;
                        margin-right: 20px;
                        border-radius: 10px;
                        padding: 20px;
                    }
                    
                    .mobile-menu-nav ul {
                        list-style: none;
                        padding: 0;
                        margin: 0;
                    }
                    
                    .mobile-menu-nav li {
                        border-bottom: 1px solid #eee;
                    }
                    
                    .mobile-menu-nav a {
                        display: block;
                        padding: 15px 10px;
                        color: #333;
                        text-decoration: none;
                        font-size: 16px;
                        font-weight: 500;
                    }
                    
                    .mobile-menu-nav .submenu {
                        background: #f9f9f9;
                        padding-left: 20px;
                        display: none;
                    }
                    
                    .mobile-menu-nav .submenu.active {
                        display: block;
                    }
                    
                    .mobile-menu-nav .has-submenu {
                        position: relative;
                    }
                    
                    .mobile-menu-nav .submenu-toggle {
                        position: absolute;
                        right: 10px;
                        top: 15px;
                        background: none;
                        border: none;
                        font-size: 16px;
                        cursor: pointer;
                    }
                    
                    .mobile-menu-close {
                        position: absolute;
                        top: 20px;
                        right: 20px;
                        background: none;
                        border: none;
                        color: white;
                        font-size: 24px;
                        cursor: pointer;
                        z-index: 1002;
                    }
                    
                    /* Hero Section */
                    .hero__caption h1 {
                        font-size: 1.8rem !important;
                    }
                    
                    .hero__caption h3 {
                        font-size: 1.1rem !important;
                        line-height: 1.4;
                    }
                    
                    /* Stats Section */
                    .row[style*="margin-left: 100px"] {
                        margin-left: 0 !important;
                        margin-right: 0 !important;
                    }
                    
                    .single-info {
                        margin-bottom: 20px !important;
                        padding: 0 10px;
                    }
                    
                    .info-caption h1 {
                        font-size: 1.8rem !important;
                    }
                    
                    /* About Section */
                    .about-caption p {
                        font-size: 18px !important;
                        line-height: 1.5;
                    }
                    
                    .about-img img {
                        width: 100% !important;
                        height: auto !important;
                        max-width: 100%;
                    }
                    
                    /* Courses Section */
                    .single-cat {
                        margin-bottom: 30px !important;
                    }
                    
                    .cat-cap p {
                        line-height: 1.5;
                        font-size: 14px;
                    }
                    
                    /* Stars Section */
                    .row[style*="margin-left: -100px"] {
                        margin-left: 0 !important;
                        margin-right: 0 !important;
                    }
                    
                    .team-img img {
                        width: 100% !important;
                        height: auto !important;
                        max-width: 100%;
                    }
                    
                    /* Testimonials */
                    .testimonial-form {
                        margin-top: 40px;
                    }
                    
                    .testimonial-form input {
                        width: 100%;
                        margin-bottom: 15px;
                    }
                    
                    /* Contact Form */
                    .contact-form-wrapper {
                        padding: 20px;
                        background: rgba(255, 255, 255, 0.9);
                    }
                    
                    .input-form input, 
                    .input-form select {
                        width: 100%;
                        margin-bottom: 15px;
                    }
                    
                    .radio-wrapper {
                        text-align: left;
                    }
                    
                    .select-radio .radio {
                        display: block;
                        margin-bottom: 10px;
                    }
                    
                    /* Footer */
                    .single-footer-caption {
                        margin-bottom: 30px !important;
                    }
                    
                    .footer-social a {
                        margin: 0 5px;
                    }
                }
                
                @media (max-width: 576px) {
                    /* Extra small devices */
                    .hero__caption h1 {
                        font-size: 1.5rem !important;
                    }
                    
                    .hero__caption h3 {
                        font-size: 1rem !important;
                    }
                    
                    .section-tittle h2 {
                        font-size: 1.5rem !important;
                    }
                    
                    .btn, .submit-btn {
                        width: 100%;
                        padding: 12px;
                    }
                    
                    .testimonial-founder {
                        flex-direction: column;
                        text-align: center;
                    }
                    
                    .founder-img {
                        margin-bottom: 10px;
                    }
                    
                    .mobile-menu-content {
                        margin-left: 10px;
                        margin-right: 10px;
                    }
                }
                
                /* Desktop styles - keep original behavior */
                @media (min-width: 769px) {
                    .mobile-menu-toggle {
                        display: none !important;
                    }
                    
                    .mobile-menu-container {
                        display: none !important;
                    }
                }

                /* Courses Section Styles for Single Row */
                .courses-row {
                    display: flex;
                    flex-wrap: nowrap;
                    justify-content: space-between;
                    gap: 20px;
                }
                
                .course-card {
                    flex: 1;
                    min-width: 0;
                }
                
                @media (max-width: 992px) {
                    .courses-row {
                        flex-wrap: wrap;
                    }
                    
                    .course-card {
                        flex: 0 0 calc(50% - 20px);
                        margin-bottom: 30px;
                    }
                }
                
                @media (max-width: 768px) {
                    .course-card {
                        flex: 0 0 100%;
                    }
                }
                `}
            </style>

            <div id="preloader-active">
                <div class="preloader d-flex align-items-center justify-content-center">
                    <div class="preloader-inner position-relative">
                        <div class="preloader-circle"></div>
                        <div class="preloader-img pere-text">
                            <img src={logo} alt="Loading..." />
                        </div>
                    </div>
                </div>
            </div>

            {/* Mobile Menu Overlay */}
            <div class={`mobile-menu-container ${isMobileMenuOpen ? 'active' : ''}`}>
                <button class="mobile-menu-close" onClick={toggleMobileMenu}>
                    <i class="fa-solid fa-times"></i>
                </button>
                <div class="mobile-menu-content">
                    <nav class="mobile-menu-nav">
                        <ul>
                            <li><a href="\" onClick={toggleMobileMenu}>Home</a></li>
                            <li><a href="About" onClick={toggleMobileMenu}>About</a></li>
                            <li class="has-submenu">
                                <a href="#" onClick={(e) => {
                                    e.preventDefault();
                                    const submenu = e.target.parentElement.querySelector('.submenu');
                                    submenu.classList.toggle('active');
                                }}>
                                    Courses
                                </a>
                                <button class="submenu-toggle">
                                    <i class="fa-solid fa-chevron-down"></i>
                                </button>
                                <ul class="submenu">
                                    <li><a href="thebeginnercourse" onClick={toggleMobileMenu}>The Beginner Course</a></li>
                                    <li><a href="theintermediatecourse" onClick={toggleMobileMenu}>The Intermediate Course</a></li>
                                    <li><a href="theadvancedcourse" onClick={toggleMobileMenu}>The Advance Course</a></li>
                                </ul>
                            </li>
                            <li><a href="gallery" onClick={toggleMobileMenu}>Gallery</a></li>
                            <li><a href="achivement" onClick={toggleMobileMenu}>Achivement</a></li>
                            <li><a href="contact" onClick={toggleMobileMenu}>Contact</a></li>
                        </ul>
                    </nav>
                </div>
            </div>

            {/* Rest of your existing code remains exactly the same */}
            <main>
                <div class="slider-area ">
                    <div class="slider-active">
                        <div class="single-slider slider-height d-flex align-items-center">
                            <div class="container">
                                <div class="row">
                                    <div class="col-xl-9 col-lg-9">
                                        <div class="hero__caption">
                                            <h1><span>King Maker Chess Academy</span></h1>
                                            <h3 style={{ color: 'white' }}>"When you see<span> a good move,</span> look for <span>a better one</span>" -
                                                Emanual Lasker
                                            </h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="our-info-area pt-70 pb-40">
                    <div class="container">
                        <div class="row" style={{ marginLeft: '100px', display: 'flex', justifyContent: 'space-between', flexWrap: 'nowrap' }}>
                            <div class="col-lg-4 col-md-6 col-sm-6" style={{ flex: '1', minWidth: '0' }}>
                                <div class="single-info mb-30 text-center">
                                    <div class="info-icon">
                                        <span> <i class="fa-solid fa-person-chalkboard"></i></span>
                                    </div>
                                    <div class="info-caption">
                                        <h1>10+</h1>
                                        <span>COACHES</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 col-sm-6" style={{ flex: '1', minWidth: '0' }}>
                                <div class="single-info mb-30 text-center">
                                    <div class="info-icon">
                                        <span><i class="fa-sharp fa-solid fa-users"></i></span>
                                    </div>
                                    <div class="info-caption">
                                        <h1>200+</h1>
                                        <span>STUDENTS</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 col-sm-6" style={{ flex: '1', minWidth: '0' }}>
                                <div class="single-info mb-30">
                                    <div class="info-icon">
                                        <span><i class="fa-solid fa-building-columns"></i></span>
                                    </div>
                                    <div class="info-caption">
                                        <h1>2+</h1>
                                        <span>CENTRES</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="about-low-area padding-bottom">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-6 col-md-12">
                                <div class="about-caption mb-50">
                                    <div class="section-tittle mb-35">
                                        <span>About Us</span>
                                        <h2>King Maker Chess Academy</h2>
                                    </div>
                                    <p style={{ fontSize: '25px' }}>We at KMCA provide chess coaching not only with the aim of
                                        promoting chess culture but
                                        also to develop one's Intelligence Quotient.</p>
                                    <a href="about.html" class="btn">Know More</a>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-12">

                                <div class="about-img ">
                                    <div class="about-font-img">
                                        <img src={chessimg4} height="500" width="700" alt="" />
                                    </div>
                                    <div class=" about-back-img d-none d-lg-block">
                                        <img src="assets/img/gallery/about1.png" alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Courses Section - All 3 cards in single row */}
                <div className="categories-area section-padding30">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="section-tittle text-center mb-80">
                                    <span>Our Courses</span>
                                    <h2>What do we provide?</h2>
                                </div>
                            </div>
                        </div>

                        <div className="courses-row">
                            {/* Beginner Course */}
                            <div className="col-lg-4 col-md-6 col-sm-6 course-card">
                                <div className="single-cat mb-50" style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                                    <div className="cat-icon text-center">
                                        <span><i className="fa-solid fa-chess-knight text-center" aria-hidden="true"></i></span>
                                    </div>
                                    <div className="cat-cap" style={{ flex: '1', display: 'flex', flexDirection: 'column' }}>
                                        <h5><a href="services.html" className="text-center">THE BEGINNER COURSE</a></h5>
                                        <p style={{ flex: '1' }}>This course is a perfect friend for a beginner.<br /> It covers: <br />
                                            - Introduction to chess <br />
                                            - Special Moves <br />
                                            - Aim Of The Game <br />
                                            - Basic Chess openings <br />
                                            - Chess Tactics <br />
                                            - End game</p>
                                    </div>
                                </div>
                            </div>

                            {/* Intermediate Course */}
                            <div className="col-lg-4 col-md-6 col-sm-6 course-card">
                                <div className="single-cat mb-50" style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                                    <div className="cat-icon text-center">
                                        <span><i className="fa-solid fa-chess-rook" aria-hidden="true"></i></span>
                                    </div>
                                    <div className="cat-cap" style={{ flex: '1', display: 'flex', flexDirection: 'column' }}>
                                        <h5><a href="services.html" className="text-center">THE INTERMEDIATE COURSE</a></h5>
                                        <p style={{ flex: '1' }}>This course is specially designed for people who are familiar with chess and know the
                                            basics but are very
                                            eager
                                            to master it. It covers: <br /> - Chess Openings (Level 2) <br /> - Chess Tactics (Level
                                            2) <br /> - End Game (Level 2) <br /> - Game Analysis</p>
                                    </div>
                                </div>
                            </div>

                            {/* Advanced Course */}
                            <div className="col-lg-4 col-md-6 col-sm-6 course-card">
                                <div className="single-cat mb-50" style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                                    <div className="cat-icon text-center">
                                        <span><i className="fa-solid fa-chess-queen" aria-hidden="true"></i></span>
                                    </div>
                                    <div className="cat-cap" style={{ flex: '1', display: 'flex', flexDirection: 'column' }}>
                                        <h5><a href="services.html" className="text-center">THE ADVANCE COURSE</a></h5>
                                        <p style={{ flex: '1' }}>Wanting to proffesionally play chess and achieve international rating? This course is
                                            just the perfect solution. It covers: <br /> - Advanced Chess Openings <br /> - Chess
                                            Combinations <br /> - Advanced Tactical Combinations (X-Rays) <br /> - End
                                            Games(Triangulation-based) <br /> - In-depth game analysis</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <br />
                        <br />
                        <br />
                    </div>
                </div>

                <div class="team-area">
                    <div class="container">
                        <div class="row justify-content-center">
                            <div class="cl-xl-7 col-lg-8 col-md-10">
                                <div class="section-tittle text-center mb-70">
                                    <span>Our youngsters who have a long way to go!</span>
                                    <h2>Our Budding Stars</h2>
                                </div>
                            </div>
                        </div>
                        <div class="row" style={{ marginLeft: '-100px', marginRight: '-100px', display: 'flex', flexWrap: 'nowrap', justifyContent: 'space-between' }}>
                            <div class="col-lg-3 col-md-4 col-sm-6" style={{ flex: '1', minWidth: '0' }}>
                                <div class="single-team mb-30 text-center">
                                    <div class="team-img">
                                        <img src={dev_image} height="400" width="300" alt="" />
                                        <div class="team-caption">
                                            <br />
                                            <h3><a href="#">Dev Raichura</a></h3>
                                            <p>FIDE RATING - 1229 <br /> AUSTRALIA RANK - 10</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-6" style={{ flex: '1', minWidth: '0' }}>
                                <div class="single-team mb-30 text-center">
                                    <div class="team-img">
                                        <img src={parv_img} height="400" width="300" alt="" />
                                        <div class="team-caption">
                                            <br />
                                            <h3><a href="#">Parv Hakani</a></h3>
                                            <p>FIDE RATING - 1201 <br /> INDIA RANK - 10 <br /> </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-6" style={{ flex: '1', minWidth: '0' }}>
                                <div class="single-team mb-30 text-center">
                                    <div class="team-img">
                                        <img src={samarth_img} height="400" width="300" alt="" />
                                        <div class="team-caption">
                                            <br />
                                            <h3><a href="#">Samarth Dolia</a></h3>
                                            <p>Represented Ireland in <br />European Youth Chess Championship 2021 & 2022</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-6" style={{ flex: '1', minWidth: '0' }}>
                                <div class="single-team mb-30 text-center">
                                    <div class="team-img">
                                        <img src={aarav_img} height="400" width="300" alt="" />
                                        <div class="team-caption">
                                            <br />
                                            <h3><a href="#">Aarav Shah</a></h3>
                                            <p>FIDE RATING - 1043 <br /> INDIA RANK - 51</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="testimonial-area testimonial-padding section-bg"
                    data-background="assets/img/gallery/section_bg04.jpg">
                    <div class="container">
                        <div class="row justify-content-between">
                            <div class="col-xl-7 col-lg-7">
                                <div class="section-tittle section-tittle2 mb-25">
                                    <span>Parents Testimonials</span>
                                    <h2>What Our Parents Say!</h2>
                                </div>

                                <div class="h1-testimonial-active mb-70" style={{ position: 'relative' }}>
                                    <Slider
                                        infinite={true}
                                        speed={800}
                                        slidesToShow={1}
                                        slidesToScroll={1}
                                        autoplaySpeed={4000}
                                        pauseOnHover={true}
                                        arrows={false}
                                    >
                                        {/* Testimonial Slides */}
                                        <div class="single-testimonial ">
                                            <div class="testimonial-caption ">
                                                <div class="testimonial-top-cap">
                                                    <p>My daughter started her chess class at the learner level and today she has
                                                        improved alot. at King Maker kids needs to go under assessment which helps
                                                        to identify their level and train accordingly. It helped my daughter to
                                                        improve her confidence, concentration and conginitive developments. Special
                                                        thanks to King Maker and Kudos to Sanket Sir (Sanvi`s Coach) for creating a
                                                        friendly environment with lots of dedication and focus on chess. Most
                                                        recommended place ever for chess.

                                                    </p>
                                                </div>
                                                <div class="testimonial-founder d-flex align-items-center">
                                                    <div class="founder-img">
                                                        <i class="fa-solid fa-user" style={{ color: '#ffffff', fontSize: '50px' }}></i>
                                                    </div>
                                                    <div class="founder-text">
                                                        <span>Kavita Hakani (mother of Parv Hakani)</span>
                                                        <p>
                                                            <i class="fa-solid fa-star" style={{ color: '#e7ca0d' }}></i>
                                                            <i class="fa-solid fa-star" style={{ color: '#e7ca0d' }}></i>
                                                            <i class="fa-solid fa-star" style={{ color: '#e7ca0d' }}></i>
                                                            <i class="fa-solid fa-star" style={{ color: '#e7ca0d' }}></i>
                                                            <i class="fa-solid fa-star" style={{ color: '#e7ca0d' }}></i>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="single-testimonial ">
                                            <div class="testimonial-caption ">
                                                <div class="testimonial-top-cap">
                                                    <p>My son has achieved his international chess rating of ELO 1201 and is one of
                                                        the best U-9 players of our country. All this was only possible due to the
                                                        efforts that King Maker Chess Academy had put to build his interest and
                                                        rapport with chess. The best place to not only master chess, but also
                                                        increase one's IQ.

                                                    </p>
                                                </div>
                                                <div class="testimonial-founder d-flex align-items-center">
                                                    <div class="founder-img">
                                                        <i class="fa-solid fa-user" style={{ color: '#ffffff', fontSize: '50px' }}></i>
                                                    </div>
                                                    <div class="founder-text">
                                                        <span>Savita Porwal</span>
                                                        <p>
                                                            <i class="fa-solid fa-star" style={{ color: '#e7ca0d' }}></i>
                                                            <i class="fa-solid fa-star" style={{ color: '#e7ca0d' }}></i>
                                                            <i class="fa-solid fa-star" style={{ color: '#e7ca0d' }}></i>
                                                            <i class="fa-solid fa-star" style={{ color: '#e7ca0d' }}></i>
                                                            <i class="fa-solid fa-star" style={{ color: '#e7ca0d' }}></i>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="single-testimonial ">
                                            <div class="testimonial-caption ">
                                                <div class="testimonial-top-cap">
                                                    <p>Value based , friendly, customized coaching. Coaches are well experienced. We
                                                        are with this institute since a year and tremendous improvement in my ward
                                                        's game.Good thing is my child enjoys to play to improve his game and not
                                                        just to win .


                                                    </p>
                                                </div>
                                                <div class="testimonial-founder d-flex align-items-center">
                                                    <div class="founder-img">
                                                        <i class="fa-solid fa-user" style={{ color: '#ffffff', fontSize: '50px' }}></i>
                                                    </div>
                                                    <div class="founder-text">
                                                        <span>Savita Porwal</span>
                                                        <p>
                                                            <i class="fa-solid fa-star" style={{ color: '#e7ca0d' }}></i>
                                                            <i class="fa-solid fa-star" style={{ color: '#e7ca0d' }}></i>
                                                            <i class="fa-solid fa-star" style={{ color: '#e7ca0d' }}></i>
                                                            <i class="fa-solid fa-star" style={{ color: '#e7ca0d' }}></i>
                                                            <i class="fa-solid fa-star" style={{ color: '#e7ca0d' }}></i>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="single-testimonial ">
                                            <div class="testimonial-caption ">
                                                <div class="testimonial-top-cap">
                                                    <p>Awesome coaches. Quality chess education. putting more emphasis on kids.
                                                    </p>
                                                </div>
                                                <div class="testimonial-founder d-flex align-items-center">
                                                    <div class="founder-img">
                                                        <i class="fa-solid fa-user" style={{ color: '#ffffff', fontSize: '50px' }}></i>
                                                    </div>
                                                    <div class="founder-text">
                                                        <span>Savita Porwal</span>
                                                        <p>
                                                            <i class="fa-solid fa-star" style={{ color: '#e7ca0d' }}></i>
                                                            <i class="fa-solid fa-star" style={{ color: '#e7ca0d' }}></i>
                                                            <i class="fa-solid fa-star" style={{ color: '#e7ca0d' }}></i>
                                                            <i class="fa-solid fa-star" style={{ color: '#e7ca0d' }}></i>
                                                            <i class="fa-solid fa-star" style={{ color: '#e7ca0d' }}></i>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="single-testimonial ">
                                            <div class="testimonial-caption ">
                                                <div class="testimonial-top-cap">
                                                    <p>We have found King Maker Chess Academy to the best Chess Coaching classes for
                                                        our children. The management is sincere in the field of Chess Training and
                                                        not money minded like others Academy. Their teachers are expert and easily
                                                        make rapport with the students. This is very good aspects since the students
                                                        are happy and are eager to learn more and more from the teacher. </p>
                                                </div>
                                                <div class="testimonial-founder d-flex align-items-center">
                                                    <div class="founder-img">
                                                        <i class="fa-solid fa-user" style={{ color: '#ffffff', fontSize: '50px' }}></i>
                                                    </div>
                                                    <div class="founder-text">
                                                        <span>Savita Porwal</span>
                                                        <p>
                                                            <i class="fa-solid fa-star" style={{ color: '#e7ca0d' }}></i>
                                                            <i class="fa-solid fa-star" style={{ color: '#e7ca0d' }}></i>
                                                            <i class="fa-solid fa-star" style={{ color: '#e7ca0d' }}></i>
                                                            <i class="fa-solid fa-star" style={{ color: '#e7ca0d' }}></i>
                                                            <i class="fa-solid fa-star" style={{ color: '#e7ca0d' }}></i>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Slider>

                                    {/* Custom CSS for VERY CLOSE buttons */}
                                    <style>
                                        {`
                        .h1-testimonial-active .slick-prev {
                            left: -45px !important;
                        }
                        .h1-testimonial-active .slick-next {
                            right: -45px !important;
                        }
                        .h1-testimonial-active .slick-prev,
                        .h1-testimonial-active .slick-next {
                            width: 40px;
                            height: 40px;
                            background: rgba(255, 255, 255, 0.3) !important;
                            border-radius: 50%;
                            z-index: 1;
                            display: flex !important;
                            align-items: center;
                            justify-content: center;
                        }
                        .h1-testimonial-active .slick-prev:hover,
                        .h1-testimonial-active .slick-next:hover {
                            background: rgba(255, 255, 255, 0.5) !important;
                        }
                        .h1-testimonial-active .slick-prev:before,
                        .h1-testimonial-active .slick-next:before {
                            display: none;
                        }
                        .h1-testimonial-active .slick-prev i,
                        .h1-testimonial-active .slick-next i {
                            color: white;
                            font-size: 18px;
                        }
                        
                        /* Mobile responsive slider buttons */
                        @media (max-width: 768px) {
                            .h1-testimonial-active .slick-prev {
                                left: 10px !important;
                            }
                            .h1-testimonial-active .slick-next {
                                right: 10px !important;
                            }
                        }
                        `}
                                    </style>
                                </div>
                            </div>

                            <div class="col-xl-4 col-lg-5 col-md-8">
                                <div class="testimonial-form text-center">
                                    <h3>Always a call away!</h3>
                                    <input type="text" placeholder="+91**********" />
                                    <button name="submit" class="submit-btn">Request a Callback</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                {/* =========================================================== */}

                <section
                    className="contact-form-area section-bg pt-115 pb-120 fix"
                    style={{
                        backgroundImage: `url(${chessimg17})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat'
                    }}
                >
                    <div className="container">
                        <div className="row justify-content-end">
                            <div className="col-xl-8 col-lg-9">
                                <div className="contact-form-wrapper">
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className="section-tittle mb-50">
                                                <span>Avail to our free demo session by filling out this form</span>
                                                <h2>Book a Demo Session</h2>
                                                <p>We'll reach out to you personally on your contact within the next 24 hours</p>
                                            </div>
                                        </div>
                                    </div>
                                    <form onSubmit={handleSubmit} className="contact-form">
                                        <div className="row">
                                            {/* 🔸 Parent Name */}
                                            <div className="col-lg-6">
                                                <div className="input-form mb-3">
                                                    <input
                                                        type="text"
                                                        name="name"
                                                        value={formData.name}
                                                        onChange={handleChange}
                                                        placeholder="Parent Name"
                                                    />
                                                    {errors.name && (
                                                        <p className="text-danger small mb-0">{errors.name}</p>
                                                    )}
                                                </div>
                                            </div>

                                            {/* 🔸 Child Name */}
                                            <div className="col-lg-6">
                                                <div className="input-form mb-3">
                                                    <input
                                                        type="text"
                                                        name="childName"
                                                        value={formData.childName}
                                                        onChange={handleChange}
                                                        placeholder="Child Name"
                                                    />
                                                    {errors.childName && (
                                                        <p className="text-danger small mb-0">{errors.childName}</p>
                                                    )}
                                                </div>
                                            </div>

                                            {/* 🔸 Contact Number */}
                                            <div className="col-lg-6">
                                                <div className="input-form mb-3">
                                                    <input
                                                        type="text"
                                                        name="contactNumber"
                                                        value={formData.contactNumber}
                                                        onChange={handleChange}
                                                        placeholder="Contact Number"
                                                    />
                                                    {errors.contactNumber && (
                                                        <p className="text-danger small mb-0">{errors.contactNumber}</p>
                                                    )}
                                                </div>
                                            </div>

                                            {/* 🔸 Email */}
                                            <div className="col-lg-6">
                                                <div className="input-form mb-3">
                                                    <input
                                                        type="email"
                                                        name="email"
                                                        value={formData.email}
                                                        onChange={handleChange}
                                                        placeholder="E-mail"
                                                    />
                                                    {errors.email && (
                                                        <p className="text-danger small mb-0">{errors.email}</p>
                                                    )}
                                                </div>
                                            </div>

                                            {/* 🔸 Familiarity */}
                                            <div className="col-lg-6">
                                                <div className="input-form mb-3">
                                                    <select
                                                        name="familiarity"
                                                        value={formData.familiarity}
                                                        onChange={handleChange}
                                                        style={{
                                                            width: "100%",
                                                            padding: "15px",
                                                            border: "1px solid #ddd",
                                                            borderRadius: "5px",
                                                            fontSize: "16px",
                                                            backgroundColor: "white",
                                                        }}
                                                    >
                                                        <option value="">Familiarity with Chess</option>
                                                        <option value="Unfamiliar">Unfamiliar</option>
                                                        <option value="Knows the Basics">Knows the Basics</option>
                                                        <option value="Playing since a long time">
                                                            Playing since a long time
                                                        </option>
                                                        <option value="Professional Rated Player">
                                                            Professional Rated Player
                                                        </option>
                                                    </select>
                                                    {errors.familiarity && (
                                                        <p className="text-danger small mb-0">{errors.familiarity}</p>
                                                    )}
                                                </div>
                                            </div>

                                            {/* 🔸 Age */}
                                            <div className="col-lg-6">
                                                <div className="input-form mb-3">
                                                    <input
                                                        type="number"
                                                        name="childAge"
                                                        value={formData.childAge}
                                                        onChange={handleChange}
                                                        placeholder="Child's Age"
                                                    />
                                                    {errors.childAge && (
                                                        <p className="text-danger small mb-0">{errors.childAge}</p>
                                                    )}
                                                </div>
                                            </div>

                                            {/* 🔸 City */}
                                            <div className="col-lg-6">
                                                <div className="input-form mb-3">
                                                    <input
                                                        type="text"
                                                        name="city"
                                                        value={formData.city}
                                                        onChange={handleChange}
                                                        placeholder="City"
                                                    />
                                                    {errors.city && (
                                                        <p className="text-danger small mb-0">{errors.city}</p>
                                                    )}
                                                </div>
                                            </div>

                                            {/* 🔸 Date */}
                                            <div className="col-lg-6">
                                                <div className="input-form mb-3">
                                                    <input
                                                        type="date"
                                                        name="preferredDate"
                                                        value={formData.preferredDate}
                                                        onChange={handleChange}
                                                    />
                                                    {errors.preferredDate && (
                                                        <p className="text-danger small mb-0">{errors.preferredDate}</p>
                                                    )}
                                                </div>
                                            </div>

                                            {/* 🔸 Demo Mode */}
                                            <div className="col-lg-12">
                                                <div className="radio-wrapper mb-3 mt-2">
                                                    <label>Demo Mode :</label>
                                                    <div className="select-radio">
                                                        {[
                                                            "Offline (At the Academy)",
                                                            "Offline (At the Child's home)",
                                                            "Online",
                                                        ].map((mode) => (
                                                            <div className="radio" key={mode}>
                                                                <input
                                                                    id={mode}
                                                                    name="demoMode"
                                                                    type="radio"
                                                                    value={mode}
                                                                    checked={formData.demoMode === mode}
                                                                    onChange={handleChange}
                                                                />
                                                                <label htmlFor={mode} className="radio-label">
                                                                    {mode}
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                    {errors.demoMode && (
                                                        <p className="text-danger small mb-0">{errors.demoMode}</p>
                                                    )}
                                                </div>
                                            </div>

                                            {/* 🔸 Submit */}
                                            <div className="col-lg-12">
                                                <button type="submit" className="submit-btn btn btn-primary mt-3">
                                                    Request a Quote
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </main >

            <div id="back-top" style={{ textAlign: 'center' }}>
                <a title="Go to Top" href="#" style={{ display: 'inline-block' }}>
                    <i className="fas fa-level-up-alt"></i>
                </a>
            </div>
        </div >
    )
}

export default Home